import esContent from './title.es';

export default {
  ...esContent,
};
